var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocumentTextSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.4 2.383a2.1 2.1 0 0 0-2.1 2.1v15.2c0 1.16.941 2.1 2.1 2.1H12a.7.7 0 1 0 0-1.4H6.4a.7.7 0 0 1-.7-.7v-15.2a.7.7 0 0 1 .7-.7h6.9v3.3a1.7 1.7 0 0 0 1.7 1.7h3.3v3.8a.7.7 0 1 0 1.4 0V8.414a1.5 1.5 0 0 0-.439-1.06l-4.53-4.532a1.5 1.5 0 0 0-1.062-.439zm10.91 5-2.61-2.61v2.31a.3.3 0 0 0 .3.3z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16 13.383a3.7 3.7 0 1 0 2.075 6.764l1.43 1.431a.7.7 0 0 0 .99-.99l-1.43-1.43A3.7 3.7 0 0 0 16 13.382m-1.626 2.074a2.3 2.3 0 1 1 3.253 3.253 2.3 2.3 0 0 1-3.253-3.253",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.3 17.083a.7.7 0 0 1 .7-.7h2a.7.7 0 1 1 0 1.4H8a.7.7 0 0 1-.7-.7M8 12.383a.7.7 0 1 0 0 1.4h4a.7.7 0 1 0 0-1.4z"
})));
export default SvgDocumentTextSearch;